import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, LoadingController } from 'ionic-angular';
import { AngularFire, FirebaseListObservable } from 'angularfire2';

import Quill from 'quill';
import moment from 'moment';

@Component({
  selector: 'page-health',
  templateUrl: 'health.html'
})
export class Health {

  // Loader
  loader: any = null;

  // Editors
  quill_en: any = null;
  quill_trm: any = null;

  // Data
  segmentModel: string = 'English';
  levelModel: any = {};
  editFlag: boolean = false;
  levels: FirebaseListObservable<any[]>;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public af: AngularFire) {
    
    this.levelModel = JSON.parse(JSON.stringify( navParams.get('level') ));
    this.editFlag = navParams.get('edit');

    this.levels = this.af.database.list(`/health`);
  }

  ionViewDidLoad() {
    let options: any = {
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline']
        ]
      },
      placeholder: 'Enter description',
      theme: 'snow'  // or 'bubble'
    };

    this.quill_en = new Quill('#editor_en', options);
    this.quill_trm = new Quill('#editor_trm', options);

    console.log('ionViewDidLoad - quill', this.quill_en, this.quill_trm);
  }

  dismissLoader() {
    if (this.loader) {
      this.loader.dismiss();
    }
  }

  dismiss() {
    this.dismissLoader();
    
    setTimeout(() => {
      this.viewCtrl.dismiss();
    }, 400);
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      dismissOnPageChange: true
    });
    this.loader.present();
  }

  validFields() {
    try {
      for (var key in this.levelModel) {

        console.log('validFields - data', key, this.levelModel[key], typeof this.levelModel[key]);

        if (key !== 'timestamp' 
          && key !== 'id'
          && key !== '$key'
          && key !== '$exists'
          && key !== 'title_trm'
          && key !== 'description_trm'
          && (typeof(this.levelModel[key]) !== "boolean") 
          && (typeof(this.levelModel[key]) !== "object")
          && !(this.levelModel[key] instanceof Array) ) {

          if (this.levelModel[key] === null || this.levelModel[key].trim() == null
            || this.levelModel[key].trim() == "" || this.levelModel[key] === " " || this.levelModel[key] === "  ") {
            return false;
          }

        }
      }
      return true;
    } catch (err) {
      console.log('Health - validFields', err);
    }
  }

  showAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: 'Harmonised',
      subTitle: message,
      buttons: ['OK']
    });
    alert.present();
  }

  showMsg(message: string) {
    this.dismissLoader();

    setTimeout(() => {
      this.showAlert(message);
    }, 400);
  }

  onClose() {
    this.dismiss();
  }

  deleteLevel() {
    try{
      console.log('saveLevel', this.levelModel);
      this.presentLoading();
      if (this.levelModel.id) {
        this.levels.remove(this.levelModel.id);
      }

      setTimeout( () => {
        this.dismiss();
      }, 600);
    } catch (error) {
      console.log('deleteLevel', error);
    }
  }

  saveLevel() {
    try{
      this.presentLoading();

      this.levelModel.description_en = this.quill_en.root.innerHTML;
      this.levelModel.description_trm = this.quill_trm.root.innerHTML;

      console.log('saveLevel', this.editFlag, this.levelModel);

      if (!this.validFields()) {
        this.showMsg('Please, fill the form correctly.');
        return;
      }
  
      // (<any>firebase).database.ServerValue.TIMESTAMP
      let tmpModel: any = {
        level: this.levelModel.level,
        title_en: this.levelModel.title_en,
        description_en: this.levelModel.description_en,
        title_trm: this.levelModel.title_trm || '',
        description_trm: this.levelModel.description_trm || '',
        timestamp: moment().unix()
      };

      if (this.editFlag) {
        this.levels.update(this.levelModel.id, tmpModel);
      } else {
        this.levels.push(tmpModel);
      }
      this.dismiss();
    } catch (error) {
      console.log('saveLevel', error);
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/health/health.ts